// extracted by mini-css-extract-plugin
module.exports = {"link-edit-column":"LinkEdit-link-edit-column--3Xw5k"};